import { defineStore } from 'pinia'
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const urls = {};

export const useFingerprintStore = defineStore('fingerprint', {
  state: () => {
    return {
      fingerprint: {},
    };
  },
  actions: {
    load: async function () {
      const fp = await FingerprintJS.load();
      this.fingerprint = await fp.get();
      console.log(this.fingerprint);
    },
  },

  getters: {
    visitorId() {
      return this.fingerprint.visitorId;
    },
  },
})